module.exports = __webpack_public_path__ + "img/timeline.a37761ef.png";